module.exports = __webpack_public_path__ + "static/media/Screenshot_3.63f3af9c.png";